import React, { useRef, useContext, useState, useEffect } from 'react';
import $ from "jquery";
import Site from '../components/settings/Site';
import AppConnectors from '../components/settings/AppConnectors';
import ZoneActivities from '../components/activity-thresholds/ZoneActivities';
import FileDashboard from './file-dashboard';
import ZoneSettings from '../components/settings/ZoneSettings';
import SensorActivities from '../components/activity-thresholds/SensorActivities';
import bootbox from 'bootbox';
import Loading from "../components/Loading";
import { Context } from './app';

const SiteManagement = (props) => {

    const appContext = useContext(Context);
    let user = appContext.user;
    let tab = window.location.hash ? window.location.hash.substring(1) : "site";
    let activity_id = '';
    if (tab === "sensor-notifications") {
        let pairs = window.location.search.substring(1).split("&"),
            obj = {},
            pair,
            i;

        for (i in pairs) {
            if (pairs[i] === "") continue;

            pair = pairs[i].split("=");
            obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
        activity_id = obj ? obj.id : '';
    }
    let siteRef = useRef(null);
    let zoneActivitiesRef = useRef(null);
    let sensorActivitiesRef = useRef(null);
    let zoneSettingsRef = useRef(null);
    // let zoneTrackingRef = useRef(null);
    let appConnectorsRef = useRef(null);
    let fileDashboardRef = useRef(null);
    const [currentTab, setCurrentTab] = useState("site");
    let zones = user.zones;

    useEffect(() => {
        $('#' + (tab) + "-tab").trigger('click');
    }, []);

    let onTabChange = (tab) => {
        if (tab === "site-notifications") {
            zoneActivitiesRef.showLoading('Fetching site notifications...')
            zoneActivitiesRef.fetchZoneActivities();
        } else if (tab === "sensor-notifications") {
            sensorActivitiesRef.showLoading('Fetching sensor settings...')
            sensorActivitiesRef.fetchSiteLocationSensors();
            sensorActivitiesRef.fetchSensorActivities();
        } else if (tab === "site-plans") {
            fileDashboardRef.fetchFilesFromS3Bucket();
        } else if (tab === "app-connectors") {
            appConnectorsRef.fetchSiteLocations();
        } else if (tab === "zone-settings") {
            zoneSettingsRef.drawTrackingPolygon();
        }

        if ((currentTab === "site" && siteRef.isModified()) ||
            (currentTab === "site-notifications" && zoneActivitiesRef.isActivityModified()) ||
            (currentTab === "sensor-notifications" && sensorActivitiesRef.isActivityModified()) ||
            (currentTab === "zone-settings" && zoneSettingsRef.modified) ||
            // (currentTab === "zone-tracking" && zoneTrackingRef.state.zone_selected && zoneTrackingRef.state.zone_selected.modified) ||
            (currentTab === "site-plans" && fileDashboardRef.modified) ||
            (currentTab === "app-connectors" && appConnectorsRef.isModified())
        ) {
            bootbox.confirm({
                message: "Do you want to save the changes made in this tab?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: "btn-primary"
                    },
                    cancel: {
                        label: 'No',
                        className: "btn-danger"
                    },
                },
                callback: (isYes) => {
                    if (isYes) {
                        switch (currentTab) {
                            case 'site':
                                siteRef.handleSave();
                                break;
                            case 'site-notifications':
                                zoneActivitiesRef.saveZoneSettings();
                                break;
                            case 'sensor-notifications':
                                sensorActivitiesRef.saveSensorSettings();
                                break;
                            case 'zone-settings':
                                zoneSettingsRef.saveTrackingConfig();
                                break;
                            case 'app-connectors':
                                appConnectorsRef.saveDailyLogSettings();
                                break;
                            case 'site-plans':
                                fileDashboardRef.saveDefaultSelectedPDF();
                                break;
                            default:
                        }
                        $(`.nav-tabs a[href="#${tab}"]`).tab('show');
                    } else {
                        $(`.nav-tabs a[href="#${tab}"]`).tab('show');
                    }
                    setCurrentTab(tab);
                }
            });
        } else {
            $(`.nav-tabs a[href="#${tab}"]`).tab('show');
            setCurrentTab(tab);
        }
    }
    return (
        <React.Fragment>
            {zones !== null ?
                <div className="page-container">
                    <div className="row">
                        <div className="col-lg-12 px-0">
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link p-1 px-3" id="site-tab" href="#site" data-toggle="tab" role="tab" onClick={() => onTabChange("site")}>
                                        Site Settings
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link p-1 px-3" id="site-notifications-tab" href="#site-notifications" data-toggle="tab" role="tab" onClick={() => onTabChange("site-notifications")}>
                                        Site Notifications
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link p-1 px-3' id='sensor-notifications-tab' href='#sensor-notifications' data-toggle="tab" role='tab' onClick={() => onTabChange("sensor-notifications")}>
                                        Sensor Notifications
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link p-1 px-3" id="zone-settings-tab" href="#zone-settings" data-toggle="tab" role="tab" onClick={() => onTabChange("zone-settings")}>
                                        Zone Settings
                                    </a>
                                </li>
                                {/* <li className="nav-item">
                                    <a className="nav-link p-1 px-3" id="zone-tracking-tab" href="#zone-tracking" data-toggle="tab" role="tab" onClick={() => this.onTabChange("zone-tracking")}>
                                        Zone Tracking
                                    </a>
                                </li> */}
                                <li className="nav-item hide">
                                    <a className="nav-link p-1 px-3" id="app-connectors-tab" href="#app-connectors" data-toggle="tab" role="tab" onClick={() => onTabChange("app-connectors")}>
                                        App Connectors
                                    </a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link p-1 px-3" id="site-plans-tab" href="#site-plans" data-toggle="tab" role="tab" onClick={() => onTabChange("site-plans")}>
                                        Site Plans
                                    </a>
                                </li>
                                {/* <li className="nav-item">
                                    <a className="nav-link p-1 px-3" id="wifi-tab" href="#wifi" role="tab">
                                        WiFi Settings
                                    </a>
                                </li> */}
                            </ul>
                            <div className="tab-content bg-white py-4 px-md-5 px-2" id="myTabContent" style={{ minHeight: "300px" }}>
                                <div className="tab-pane fade" id="site" role="tabpanel" aria-labelledby="site-tab">
                                    <Site ref={x => siteRef = x} user={user}></Site>
                                </div>

                                <div className="tab-pane fade" id="site-notifications" role="tabpanel" aria-labelledby="zone-activities-tab">
                                    <ZoneActivities title="Site Notifications" ref={x => zoneActivitiesRef = x}></ZoneActivities>
                                </div>

                                <div className='tab-pane fade' id='sensor-notifications' role='tabpanel' aria-labelledby='sensor-notifications-tab'>
                                    <SensorActivities activity_id={activity_id || ''} user={user} title='Sensor Notifications' ref={x => sensorActivitiesRef = x}></SensorActivities>
                                </div>

                                <div className="tab-pane fade" id="zone-settings" role="tabpanel" aria-labelledby="zone-settings-tab">
                                    <ZoneSettings title="Zone Settings" user={user} ref={x => zoneSettingsRef = x}></ZoneSettings>
                                </div>

                                {/* <div className="tab-pane fade" id="zone-tracking" role="tabpanel" aria-labelledby="zone-tracking-tab">
                                    <ZoneTracking title="Zone Tracking" ref={x => zoneTrackingRef = x}></ZoneTracking>
                                </div> */}

                                <div className="tab-pane fade hide" id="app-connectors" role="tabpanel" aria-labelledby="app-connectors-tab">
                                    <AppConnectors ref={x => appConnectorsRef = x} user={user}></AppConnectors>
                                </div>

                                <div className="tab-pane fade" id="site-plans" role="tabpanel" aria-labelledby="site-plans-tab">
                                    <FileDashboard ref={x => fileDashboardRef = x} user={user}></FileDashboard>
                                </div>

                                {/* <div className="tab-pane fade" id="wifi" role="tabpanel" aria-labelledby="wifi-tab">
                                    <WifiSettings></WifiSettings>
                                </div> */}

                            </div>
                        </div>
                    </div>

                </div> : <React.Fragment>
                    <div className="page-container">
                        <Loading>Loading ...</Loading>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
}

export default SiteManagement;